'use strict'

import React from 'react'
import reactCSS from 'reactcss'
import {SketchPicker} from 'react-color'

import './ColorsSelector.scss'

import colorsSelectorIcon from '../../assets/colors_selector_icon.png';

import {hexToRgb} from '../../helpers/utils';
import {Grid} from "@mui/material";
import {AsyncImageWithLoader} from "../imageWithLoader/imageWithLoader";
import {ReactComponent as CameraIcon} from "../../assets/camera_icon.svg";

class ColorSelector extends React.Component {

    constructor(props) {
        super(props)

        this.color1 = '#EB3223';
        this.color2 = '#DF8244';
        this.color3 = '#4EAC5B';
        this.color4 = '#3F552A';
        this.color5 = '#2A70BA';
        this.color6 = '#04215C';
        this.color7 = '#7B601D';
        this.color8 = '#595959';

        // this.colors = [
        //     this.pink1,
        //     this.blue1,
        //     this.pink1,
        //     this.pink1,
        //     this.pink1
        // ];
        this.state = {
            displayColorPicker: false,
            /*color: {
                r: '241',
                g: '112',
                b: '19',
                a: '1',
            },
            currentSelectedColor: this.pink1*/
            backgroundUrl: props.type === 'backgroundColor' && props.backgroundImageURL ? props.backgroundImageURL : null,
            type: props.type,
            isImageUrl: props.isImageUrlSelected,
            color: hexToRgb(props.currentSelectedColor),
            currentSelectedColor: props.currentSelectedColor,
            abovePosition: Boolean(props.abovePosition)
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentSelectedColor !== this.props.currentSelectedColor || prevProps.backgroundImageURL !== this.props.backgroundImageURL || prevProps.isImageUrlSelected !== this.props.isImageUrlSelected) {
            const nextState = {
                ...this.state,
                backgroundUrl: this.props.type === 'backgroundColor' && this.props.backgroundImageURL ? this.props.backgroundImageURL : null,
                color: hexToRgb(this.props.currentSelectedColor),
                currentSelectedColor: this.props.currentSelectedColor,
                isImageUrl: this.props.isImageUrlSelected
            };
            this.setState(nextState)
        }
    }

    // will be called each time props will change
    /*static getDerivedStateFromProps(nextProps, current_state) {
        if (nextProps.currentSelectedColor && 
            current_state.currentSelectedColor !== nextProps.currentSelectedColor) {
            const nextState = {
                ...current_state,
                color: hexToRgb(nextProps.currentSelectedColor),
                currentSelectedColor: nextProps.currentSelectedColor
            }
            return nextState;
        }
        return null
    }*/

    onDynamicColorSwatchClick = () => {
        this.setState({displayColorPicker: !this.state.displayColorPicker})
    };

    handleClose = () => {
        this.setState({displayColorPicker: false})
    };

    handleChange = (nextColor) => {
        this.setState({color: nextColor.rgb})
        this.setState({currentSelectedColor: nextColor.hex})

        //
        this.props.onColorSwatchChange(nextColor.hex);
    };

    onColorSwatchClick = (nextColor) => {
        this.setState({currentSelectedColor: nextColor})

        //
        this.props.onColorSwatchChange(nextColor);
    }

    render() {

        const styles = reactCSS({
            'default': {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(
                        ${this.state.color.r}, 
                        ${this.state.color.g}, 
                        ${this.state.color.b}, 
                        ${this.state.color.a}
                    )`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    top: this.state.abovePosition ? `-316px` : `auto`,
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        return (
            <>
                <Grid container columnSpacing={1} className='colors_selector2' height={`100%`}>
                    <Grid item xs={2}>
                        <div className="theme_color_indicator">
                            {this.state.backgroundUrl && this.state.isImageUrl
                                ? <AsyncImageWithLoader
                                    src={this.state.backgroundUrl}
                                    notUploadIcon={(<CameraIcon/>)}
                                />

                                : <div className={this.state.type === 'color' ? 'color_swatch' : 'background_swatch'}
                                       style={{backgroundColor: this.state.currentSelectedColor}}/>
                            }
                        </div>
                    </Grid>
                    <Grid item xs sx={{position: `relative`}}>
                        <div className="color_swatchers">
                            <div
                                className="color_swatch color_swatch1"
                                onClick={() => this.onColorSwatchClick(this.color1)}
                                style={{backgroundColor: this.color1}}
                            />

                            <div
                                className="color_swatch color_swatch2"
                                onClick={() => this.onColorSwatchClick(this.color2)}
                                style={{backgroundColor: this.color2}}
                            />

                            <div
                                className="color_swatch color_swatch3"
                                onClick={() => this.onColorSwatchClick(this.color3)}
                                style={{backgroundColor: this.color3}}
                            />

                            <div
                                className="color_swatch color_swatch4"
                                onClick={() => this.onColorSwatchClick(this.color4)}
                                style={{backgroundColor: this.color4}}
                            />

                            <div
                                className="color_swatch color_swatch5"
                                onClick={() => this.onColorSwatchClick(this.color5)}
                                style={{backgroundColor: this.color5}}
                            />

                            <div
                                className="color_swatch color_swatch5"
                                onClick={() => this.onColorSwatchClick(this.color6)}
                                style={{backgroundColor: this.color6}}
                            />

                            <div
                                className="color_swatch color_swatch5"
                                onClick={() => this.onColorSwatchClick(this.color7)}
                                style={{backgroundColor: this.color7}}
                            />

                            <div
                                className="color_swatch color_swatch5"
                                onClick={() => this.onColorSwatchClick(this.color8)}
                                style={{backgroundColor: this.color8}}
                            />

                            <div
                                className="color_swatch_icon_container color_swatch6"
                                onClick={this.onDynamicColorSwatchClick}>
                                <img className="colors_swatch_icon" src={colorsSelectorIcon} alt={``}/>
                            </div>
                        </div>

                        {this.state.displayColorPicker &&

                            <div style={styles.popover}>
                                <div style={styles.cover} onClick={this.handleClose}/>
                                <SketchPicker
                                    color={this.state.color}
                                    onChange={this.handleChange}
                                />
                            </div>
                        }


                    </Grid>
                </Grid>
            </>
        )
    }
}

export default ColorSelector